import { useAxios } from "../../hooks/useAxios";
import { Pagination } from "../types";
import { User } from "./users";

// request + response types

interface UserPathParams {
  id: string;
}

interface CreateUserParams {
  name: string;
  email: string;
  password: string;
  admin: boolean;
  missionId?: string;
  active?: boolean;
}

interface UpdateUserParams {
  id: string;
  missionId?: string;
  active?: boolean;
}

type UsersEndpointConfig = {
  GET_USER: EndpointConfig<
    UserPathParams,
    User
  >;
  GET_ME: EndpointConfig<
    {
      cognitoId: string
    },
    User
  >;
  GET_USERS: EndpointConfig<
    Pagination,
    {
      total: number;
      results: User[]
    }
  >;
  CREATE_USER: EndpointConfig<
    CreateUserParams,
    User
  >;
  UPDATE_USER: EndpointConfig<
    UpdateUserParams,
    User
  >;
  DELETE_USER: EndpointConfig<
    UserPathParams,
    null
  >;
  GET_PARTNERS: EndpointConfig<
    Record<string, never>,
    { results: User[] }
  >;
};

// users api specific logic

const requestInitialisers: RequestConfig<UsersEndpointConfig> = {
  GET_USER: (
    ({ id }) => ({
      url: `/user/${id}`,
      method: "GET"
    })
  ),
  GET_ME: (
    ({ cognitoId }) => ({
      url: "/me",
      params: { cognitoId },
      method: "GET"
    })
  ),
  GET_USERS: (
    params => ({
      url: "/user",
      method: "GET",
      params
    })
  ),
  CREATE_USER: (
    params => ({
      url: "/user",
      method: "POST",
      data: params
    })
  ),
  UPDATE_USER: (
    ({ id, ...params }) => ({
      url: `/user/${id}`,
      method: "PUT",
      data: params
    })
  ),
  DELETE_USER: (
    ({ id }) => ({
      url: `/user/${id}`,
      method: "DELETE"
    })
  ),
  GET_PARTNERS: (
    () => ({
      url: "/user/partners",
      method: "GET"
    })
  )
};

export const useUsersApi: UseApiRequest<UsersEndpointConfig> = name => useAxios(requestInitialisers[ name ]);
